const timeProcess = (time: string) => {
  return new Intl.DateTimeFormat("zh-TW", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hour12: false,
    minute: "2-digit",
  }).format(new Date(time));
};

const isTimeExpiredAfterOneYear = (dateTimeString: string): boolean => {
  try {
    // 解析輸入的時間字串
    const inputDate = new Date(dateTimeString);
    
    // 檢查日期是否有效
    if (isNaN(inputDate.getTime())) {
      throw new Error('無效的日期格式');
    }
    
    // 獲取當前時間
    const currentDate = new Date();
    
    // 計算一年後的時間
    const oneYearLater = new Date(inputDate);
    oneYearLater.setFullYear(inputDate.getFullYear() + 1);
    
    // 比較當前時間是否超過一年後的時間
    return currentDate > oneYearLater;
    
  } catch (error) {
    console.error('日期處理錯誤:', error);
    return false;
  }
};

export { timeProcess, isTimeExpiredAfterOneYear };